import Component from '@glimmer/component';
import { service } from '@ember/service';
import CurrentUser from 'donor-elf-web/services/current-user';
import FundGoalService from 'donor-elf-web/services/fund-goal-service';
import FundsService from 'donor-elf-web/services/funds-service';
import Settings from 'donor-elf-web/services/settings';
import { action } from '@ember/object';
import { svgJar } from 'ember-svg-jar/helpers/svg-jar';
import campaignsEnabled from 'donor-elf-web/helpers/campaigns-enabled';
import hasAbility from 'donor-elf-web/helpers/has-ability';
import { LinkTo } from '@ember/routing';
import { on } from '@ember/modifier';
import BasicDropdown from 'ember-basic-dropdown/components/basic-dropdown';
import { fn } from '@ember/helper';

export default class NavbarReports extends Component {
  @service declare currentUser: CurrentUser;
  @service declare customReports: any;
  @service declare fundGoalService: FundGoalService;
  @service declare fundsService: FundsService;
  @service declare settings: Settings;

  get hasYtdGoalType() {
    return this.fundGoalService.hasYtdGoalType;
  }

  get hasOmsMonthlySummaryCustomReport() {
    return this.settings.fundSettings?.customReports?.includes(
      'oms-monthly-summary',
    );
  }

  closeDropdown = (dropdown: any) => {
    setTimeout(() => {
      dropdown.actions.close();
    }, 1);
  };

  <template>
    <BasicDropdown @verticalPosition='below' as |dd|>
      <dd.Trigger>
        <button class='btn btn-outline-brand'>Reports
          {{svgJar 'angle-down'}}</button>
      </dd.Trigger>
      <dd.Content class='navbar-dropdown-content'>
        <ul
          {{on 'click' (fn this.closeDropdown dd)}}
          class='list-group'
          role='button'
        >
          <li class='list-group-item'>
            <LinkTo @route='funds.fund.contacts' class='nav-link'>
              Contacts
            </LinkTo>
          </li>
          {{#if (campaignsEnabled)}}
            <li class='list-group-item'>
              <LinkTo
                @route='funds.fund.campaigns'
                @model={{this.fundsService.selectedFund.id}}
                class='nav-link'
              >
                Campaigns
              </LinkTo>
            </li>
          {{/if}}
          {{#if (hasAbility 'journal')}}
            <li class='list-group-item'>
              <LinkTo
                @route='funds.fund.journals'
                @model={{this.fundsService.selectedFund.id}}
                class='nav-link'
              >Journals</LinkTo>
            </li>
          {{/if}}
          <li class='list-group-item'>
            <LinkTo @route='funds.fund.tasks' class='nav-link'>
              Tasks
            </LinkTo>
          </li>
          <li class='list-group-item'>
            <LinkTo
              @route='funds.fund.donations-by-month'
              @model={{this.fundsService.selectedFund.id}}
              class='nav-link'
            >Donations by Month/Year</LinkTo>
          </li>
          <li class='list-group-item'>
            <LinkTo @route='funds.fund.transactions' class='nav-link'>
              Transactions
            </LinkTo>
          </li>
          {{#if (hasAbility 'feature_flag_1')}}
            <li class='list-group-item'>
              <LinkTo @route='funds.fund.annual-comparison' class='nav-link'>
                Annual Comparison
              </LinkTo>
            </li>
          {{/if}}
          {{#if this.hasOmsMonthlySummaryCustomReport}}
            <li class='list-group-item'>
              <LinkTo
                @route='funds.fund.custom-reports.oms-monthly-summary'
                class='nav-link'
              >
                OMS Monthly Summary
              </LinkTo>
            </li>
          {{else}}
            <li class='list-group-item'>
              <LinkTo
                @route='funds.fund.monthly-summary'
                @model={{this.fundsService.selectedFund.id}}
                class='nav-link'
              >Monthly Summary</LinkTo>
            </li>
          {{/if}}
          <li class='list-group-item'>
            <LinkTo
              @route='funds.fund.donors-by-time-frame'
              @model={{this.fundsService.selectedFund.id}}
              class='nav-link'
            >Donors by Time Frame</LinkTo>
          </li>
          <li class='list-group-item'>
            <LinkTo
              @route='funds.fund.pledges'
              @model={{this.fundsService.selectedFund.id}}
              class='nav-link'
            >Pledges</LinkTo>
          </li>
          <li class='list-group-item'>
            <LinkTo
              @route='funds.fund.pledge-fulfillment'
              @model={{this.fundsService.selectedFund.id}}
              class='nav-link'
            >Pledge Fulfillment</LinkTo>
          </li>
          <li class='list-group-item'>
            <LinkTo
              @route='funds.fund.news-feed'
              @model={{this.fundsService.selectedFund.id}}
              class='nav-link'
            >News Feed</LinkTo>
          </li>
          {{#if (hasAbility 'review_items')}}
            <li class='list-group-item'>
              <LinkTo @route='funds.fund.review-items' class='nav-link'>
                Review Items
              </LinkTo>
            </li>
          {{/if}}
          {{#if (hasAbility 'edit_contact')}}
            <li class='list-group-item'>
              <LinkTo
                @route='funds.fund.dates'
                @model={{this.fundsService.selectedFund.id}}
                class='nav-link'
              >Dates</LinkTo>
            </li>
          {{/if}}
          {{#if (hasAbility 'view_contact_name')}}
            <li class='list-group-item'>
              <LinkTo
                @route='funds.fund.map-my-contacts'
                @model={{this.fundsService.selectedFund.id}}
                class='nav-link'
              >Map My Contacts</LinkTo>
            </li>
          {{/if}}
          {{#if this.hasYtdGoalType}}
            <li class='list-group-item'>
              <LinkTo
                @route='funds.fund.ytd-next-year-projection'
                @model={{this.fundsService.selectedFund.id}}
                class='nav-link'
              >Next Year Projection</LinkTo>
            </li>
          {{/if}}
          {{#each this.customReports.reports as |report|}}
            <li class='list-group-item'>
              <LinkTo
                @route={{report.routeName}}
                @model={{this.fundsService.selectedFund.id}}
                class='nav-link'
              >{{report.label}}</LinkTo>
            </li>
          {{/each}}
          {{#if this.currentUser.hasMultipleFunds}}
            <li class='list-group-item'>
              <LinkTo
                @route='funds.fund.funds-summary'
                @model={{this.fundsService.selectedFund.id}}
                class='nav-link'
              >All Funds Summary</LinkTo>
            </li>
          {{/if}}
        </ul>
      </dd.Content>
    </BasicDropdown>
  </template>
}
